"use client";
import React from "react";
import { cn } from "@/lib/utils/global-utils";

export interface SidebarProps extends React.HTMLAttributes<HTMLDivElement> {}

const Sidebar = React.forwardRef<HTMLDivElement, SidebarProps>(
  ({ className, ...rest }, ref) => {
    return (
      <div
        {...rest}
        ref={ref}
        className={cn(
          " flex flex-row border-t bg-lewk-blue w-full h-10 items-center px-4 gap-2 justify-evenly lg:w-48 lg:h-full lg:bg-white lg:border-t-0 lg:flex-col lg:justify-normal lg:px-0 lg:py-4 lg:items-start lg:pl-2   ",
          className
        )}
      />
    );
  }
);

export { Sidebar };
